import { Link } from "react-router-dom";
import { AiOutlineCopyright } from "react-icons/ai";
import FadeIn from "../common/FadeIn";
import { allMenuLinks } from "../../constants/navigation";
import footerLeftImg from "../../assets/images/footerLeft.png";
import footerRightImg from "../../assets/images/footerRight.png";
import footer1Img from "../../assets/images/footer1.png";
import footer2Img from "../../assets/images/footer2.png";
import footer3Img from "../../assets/images/footer3.png";
import footer4Img from "../../assets/images/footer4.png";

const Footer = () => {
  return (
    <>
      <div className="relative w-full h-[60vh] md:h-[70vh] sticky top-[54px] xl:top-[103px] z-10 overflow-hidden">
        <FadeIn className="w-full h-full">
          <div className="flex flex-row w-full h-full p-0 m-0 bg-amber-500 relative">
            <div className="relative w-1/2 h-full">
              <img
                className="w-full h-full object-cover p-0 m-0 block"
                src={footerLeftImg}
                alt="SeaSalt Creative Studio Footer Background Left"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-black/25 sm:bg-transparent"></div>
            </div>

            <div className="relative w-1/2 h-full">
              <img
                className="w-full h-full object-cover object-[80%_80%] md:object-right p-0 m-0 block"
                src={footerRightImg}
                alt="SeaSalt Creative Studio Footer Background Right"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-black/25 sm:bg-transparent"></div>
            </div>
          </div>
        </FadeIn>

        <div className="absolute inset-0 flex flex-col justify-between p-6 sm:p-8 md:p-10 lg:p-12 text-white select-none z-20 bg-black/10">
          <div className="w-full text-center pt-[30px] md:pt-[36px] px-[20px] md:px-0">
            <FadeIn>
              <p className="font-GoogleSans text-[12px] md:text-[14px] text-[#fcfcfc] uppercase text-center leading-[1.3] tracking-[0.1em] font-bold mb-3 md:mb-[24px]">
                Whenever you are ready
              </p>
            </FadeIn>
            <FadeIn>
              <h2 className="font-PromenadeItalic text-[20px] md:text-[34px] font-normal leading-tight text-white max-w-4xl mx-auto">
                Let's build a website that feels like you.
              </h2>
            </FadeIn>
          </div>

          <div className="w-full flex flex-col md:flex-row items-end justify-between gap-14 md:gap-6 pb-6 sm:pb-8 ">
            <div className="max-w-xs sm:max-w-sm md:max-w-md mx-auto md:mx-0 text-center md:text-left px-[33px] md:px-0">
              <FadeIn>
                <p className="font-GoogleSans text-[12px] md:text-base leading-[1.6] tracking-[0em] font-normal text-justify md:text-left">
                  &nbsp; &nbsp; &nbsp;You bring the idea, the work, and the vision. I will turn it into a website that looks good, feels natural, and gives your business a place to grow.
                </p>
              </FadeIn>
            </div>

            <div className="flex flex-col items-center md:items-end space-y-3 w-full md:w-auto text-center md:text-right">
              <FadeIn>
                <p className="font-GoogleSans text-[14px] md:text-base text-center md:text-right font-normal leading-[1.6] tracking-[0em] w-full">
                  Websites Setup at $299
                </p>
              </FadeIn>
              <FadeIn>
                <Link
                  to="/inquiry"
                  className="inline-block border border-[#fcfcfc] font-montserratMedium text-[9px] lg:text-[11px] uppercase tracking-widest text-white hover:text-black hover:bg-[#ccc3ad] transition-all duration-[0.5s] p-[14px_20px_12px_20px]"
                >
                  INQUIRE TO START
                </Link>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>

      <footer
        className="relative z-20 w-full h-[77vh] text-justify md:h-[89.2vh] bg-[#dedcd3] pt-[10px] flex flex-col justify-between"
      >
        <div>
          <div className="bg-[#2c231b] h-[1px] mb-[2px] w-full"></div>
          <div className="bg-[#2c231b] h-[1px] w-full"></div>
          <div className="px-[29px] md:px-0">
            <FadeIn>
              <div className="font-saolDisplayItalic mt-[80px] md:mt-[130px] text-[40px] md:text-[60px] text-center uppercase">
                SeaSalt Creative
              </div>
            </FadeIn>
            <FadeIn>
              <div className="hidden md:flex flex-wrap justify-center items-center gap-4 sm:gap-6 md:gap-8 font-inter-display-medium my-6 md:my-10 text-center leading-[1.9] tracking-[0.1em] text-[13px] md:text-[14px] font-medium px-4">
                {allMenuLinks.map((link) => (
                  <Link
                    key={link.name}
                    to={link.href}
                    className="hover:text-[#6A765A] cursor-pointer"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </FadeIn>

            <FadeIn>
              <div className="container mx-auto grid grid-cols-2 md:flex md:flex-row items-center justify-center gap-3 w-fit">
                <div className="border-b">
                  <img className="responsive-img-size object-top"
                    src={footer1Img}
                    alt="SeaSalt Creative Studio Portfolio Gallery 1"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="border-b">
                  <img className="responsive-img-size"
                    src={footer2Img}
                    alt="SeaSalt Creative Studio Portfolio Gallery 2"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="border-b">
                  <img className="responsive-img-size"
                    src={footer3Img}
                    alt="SeaSalt Creative Studio Portfolio Gallery 3"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="border-b">
                  <img className="responsive-img-size"
                    src={footer4Img}
                    alt="SeaSalt Creative Studio Portfolio Gallery 4"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
        <FadeIn>
          <div className="font-PromenadeItalic mt-[58px] text-center leading-[1.2] tracking-[0em] text-[20px] md:text-[24px] font-normal px-[29px] md:px-0">
            Professional websites made to fit your brand.
            <br />
            Based in India, working with clients worldwide.
          </div>
        </FadeIn>
        <div className="flex items-center justify-between py-[17px] md:py-[19px] px-[15px] font-inter-display-medium text-[9px] md:text-[12px] leading-[1.6] tracking-[0em] font-normal border-t border-[#2c231b] mt-auto">
          <p className="flex items-center gap-2">
            <AiOutlineCopyright /> 2026 SeaSalt Creative by Princy Patel
          </p>
          <Link to="/terms" className="hover:text-[#6A765A] cursor-pointer">
            Terms & Conditions
          </Link>
        </div>
      </footer>
    </>
  );
};

export default Footer;
